import React from 'react';
import Badge from '@material-ui/core/Badge';
import { withStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import useUserInfo from '../../hooks/useUserInfo';

const StyledBadge = withStyles((theme) => ({
  badge: {
    border: `2px solid ${theme.palette.background.paper}`,
    padding: '0 4px',
    background: 'white',
    fontWeight: 600
  },
}))(Badge);

export default function CustomizedBadges(props) {
 let {notificationCount} = useUserInfo();
  return (
    <IconButton aria-label="cart" className='right-class'>
      <StyledBadge badgeContent={notificationCount} color="default" overlap='rectangular'>
      </StyledBadge>
    </IconButton>
  );
}


// WEBPACK FOOTER //
// ./src/components/Layout/CustomizedBadges.js